import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import * as styles from './hero.module.css';

import Checkmark from '../icons/checkmark-black.svg';

import Confetti from '../images/hero/confetti.svg';
import classNames from 'classnames';

const Hero = ({
  breadcrumbs,
  title,
  titleMobile,
  subtitleMarkdown,
  extraMarkdown,
  children,
  marginBottom,
  confettiBg,
  lightBg,
  uspList,
  leftAligned,
  rightAlignedText,
  smallTitle,
  topOffset,
  titleMaxWidth,
}) => {
  const Breadcrumbs = () => {
    return (
      <div className={styles.breadcrumbs}>
        {breadcrumbs.map(b => (
          <span key={b.path} className={styles.breadcrumbWrapper}>
            <Link to={b.path} className={styles.breadcrumb}>
              {b.name}
            </Link>
            <span className={styles.breadcrumbDivider}>/</span>
          </span>
        ))}
      </div>
    );
  };

  return (
    <>
      <div
        className={classNames({
          [styles.heroWrapper]: true,
          [styles.lightBg]: lightBg,
          [styles.leftAligned]: leftAligned,
          [styles.rightAlignedText]: rightAlignedText,
        })}
        style={{ marginBottom }}
      >
        {/*
        {!lightBg && (
          <div className={styles.heroBg}>
            <div className={styles.blob1} />
            <div className={styles.blob2} />
            <div className={styles.blob3} />
          </div>
        )}
        */}

        {confettiBg && (
          <div
            style={{ backgroundImage: `url("${Confetti}")` }}
            className={styles.confetti}
          />
        )}

        <div className={styles.heroContent} style={{ paddingTop: topOffset }}>
          <div className={styles.heroText}>
            {breadcrumbs && <Breadcrumbs />}
            <h1
              className={[
                styles.desktopTitle,
                smallTitle ? styles.small : '',
              ].join(' ')}
              style={{ maxWidth: titleMaxWidth }}
            >
              {title}
            </h1>
            <h1
              className={[
                styles.mobileTitle,
                smallTitle ? styles.small : '',
              ].join(' ')}
              style={{ maxWidth: titleMaxWidth }}
            >
              {titleMobile || title}
            </h1>
            {subtitleMarkdown && (
              <div className={styles.subtitle}>
                <ReactMarkdown>{subtitleMarkdown}</ReactMarkdown>
              </div>
            )}
            {extraMarkdown && (
              <div className={styles.extraContent}>
                <ReactMarkdown>{extraMarkdown}</ReactMarkdown>
              </div>
            )}
            {uspList && (
              <div className={styles.uspList}>
                {uspList.map(usp => (
                  <div className={styles.usp} key={usp}>
                    <Checkmark />
                    {usp}
                  </div>
                ))}
              </div>
            )}
          </div>
          {children && <div className={styles.children}>{children}</div>}
        </div>
      </div>
      <a name="main-content"></a>
    </>
  );
};

Hero.propTypes = {
  breadcrumbs: PropTypes.array,
  title: PropTypes.string,
  titleMobile: PropTypes.string,
  subtitleMarkdown: PropTypes.string,
  children: PropTypes.element,
  marginBottom: PropTypes.number,
  extraMarkdown: PropTypes.string,
  confettiBg: PropTypes.bool,
  lightBg: PropTypes.bool,

  uspList: PropTypes.array,
  leftAligned: PropTypes.bool,
  rightAlignedText: PropTypes.bool,
  smallTitle: PropTypes.bool,

  topOffset: PropTypes.number,
  titleMaxWidth: PropTypes.number,
};

export default Hero;
